import React from "react";
import { twMerge } from "tailwind-merge";
import { Loader2 } from "lucide-react";

const Button = React.forwardRef(
  (
    {
      variant = "primary",
      size = "md",
      isLoading = false,
      disabled = false,
      className,
      children,
      ...props
    },
    ref
  ) => {
    const baseStyles = `
    inline-flex items-center justify-center gap-2 font-medium transition-all duration-200
    disabled:opacity-50 disabled:cursor-not-allowed
    focus:outline-none focus:ring-2 focus:ring-offset-2
  `;

    const variants = {
      primary: `
      bg-primary text-white hover:bg-primary/90 
      focus:ring-primary/50 shadow-md hover:shadow-lg
    `,
      secondary: `
      bg-secondary text-white hover:bg-secondary/90 
      focus:ring-secondary/50 shadow-md hover:shadow-lg
    `,
      cta: `
      bg-cta text-white hover:bg-cta/90 
      focus:ring-cta/50 shadow-md hover:shadow-lg
      transform hover:scale-[1.02] hover:shadow-xl
    `,
      outline: `
      border-2 border-primary text-primary bg-transparent
      hover:bg-primary hover:text-white
      focus:ring-primary/50
    `,
      ghost: `
      text-neutral-700 hover:bg-neutral-100 
      focus:ring-neutral-300
    `,
      link: `
      text-primary hover:text-primary/80 underline-offset-4
      hover:underline p-0 h-auto
    `,
    };

    const sizes = {
      sm: "px-3 py-1.5 text-sm rounded-lg",
      md: "px-4 py-2 text-base rounded-xl",
      lg: "px-6 py-3 text-lg rounded-xl",
      xl: "px-8 py-4 text-xl rounded-2xl",
    };

    const buttonClasses = twMerge(baseStyles, variants[variant], sizes[size], className);

    return (
      <button ref={ref} className={buttonClasses} disabled={disabled || isLoading} {...props}>
        {isLoading && <Loader2 className="w-4 h-4 mr-2 animate-spin" />}
        {children}
      </button>
    );
  }
);

Button.displayName = "Button";

export default Button;
